<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 12H21M21 12L17 8M21 12L17 16M9 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>